import React, { type MutableRefObject } from 'react';

export const useCombineRefs = (...refs: any): MutableRefObject<any> => {
  const targetRef = React.useRef<any>(null);

  React.useEffect(() => {
    refs.forEach((ref: any) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};
